import { graphql } from '../gql';

const getShortFormsQuery = graphql(`
query getShortForms($sportName: String, $cursor: String) {
  getShortForms(filter: { sportName: $sportName, afterCursor: $cursor }) {
    pageInfo {
      cursor
      hasNextPage
    }
    shortForms {
      cursor
      entity {
        id
        title
        body
        description
        seo {
          description
        }
        publishedDate
        tags {
          name
          type
          thumbnailImage {
            url
          }
        }
      }
    }
  }
}
`);

export default getShortFormsQuery;
